import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/memberVisitsSaga";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

import MembershipTypeFilter from "./smartComponents/MembershipType";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import UpdateBtns from "./smartComponents/UpdateBtns";
import DataPoints from "./smartComponents/DataPoints";
import PieCharts from "./smartComponents/PieCharts";
import MemberVisitsView from "./smartComponents/MemberVisitsView";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { PeriodType } from "./smartComponents/PeriodType";
import Scorecards from "./smartComponents/Scorecards";
import SingleDatePicker from "./smartComponents/SingleDatePicker";
import CrossClubRankingTable from "./smartComponents/CrossClubRankingTable";

import NoData from "../../../components/noData/noData";
import "./memberVisitsModule.scss";

export const MemberVisitsModule = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    initialRequest,
    updatesLoading,
    selectedFilters: { membership_types, moduleView }
  } = useSelector((state) => state.memberVisits);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  return (
    <div id="memberVisitsModule">
      <SectionToggle
        autoHeight
        isLoading={isLoading}
        title="Member Visits"
        learnMore={
          <>
            <MemberVisitsView />
            <KBLearnMore
              title="Member Visits"
              description="This report shows members who check in or take classes at locations other than their assigned home club. These insights help you understand member movement, cross-location usage, and how multi-club behavior affects attendance patterns."
              kbUrl={ILEARN_URLS.membership.memberVisits}
            />
          </>
        }
        content={
          moduleView.id === "inStoreVsCrossClub" ? (
            membership_types.length ? (
              <>
                <div className="top__filters edit-selections-bar">
                  <div className="top__filters-left">
                    <MembershipTypeFilter />
                  </div>
                  <div className="top__filters-right">
                    <CustomDateRanges />
                    <DatePicker />
                  </div>

                  <UpdateBtns />
                </div>
                {updatesLoading ? (
                  <LoadingAnimation text="Updating data..." />
                ) : (
                  <>
                    <DataPoints />
                    <PieCharts />
                  </>
                )}
              </>
            ) : (
              <NoData />
            )
          ) : (
            <>
              <div className="top__filters edit-selections-bar">
                <div className="top__filters-left">
                  <PeriodType />
                </div>
                <div className="top__filters-right">
                  <SingleDatePicker />
                </div>
                <UpdateBtns />
              </div>
              {updatesLoading ? (
                <LoadingAnimation text="Updating data..." />
              ) : (
                <>
                  <Scorecards />
                  <CrossClubRankingTable />
                </>
              )}
            </>
          )
        }
      />
    </div>
  );
};
